import moment from 'moment-timezone'

export class Time {
  /**
   * Return the current Unix timestamp in seconds (e.g. number of seconds since midnight UTC on Jan 1st 1970)
   */
  public static getNowTs(): number {
    return this.msToTs(Date.now())
  }

  /**
   * Convert a Date object into a Unix timestamp in seconds.
   */
  public static toTs(date: Date): number {
    return this.msToTs(date.getTime())
  }

  /**
   * Convert a Unix timestamp in seconds into a Date object.
   */
  public static unixSecondsToDate(seconds: number): Date {
    return new Date(seconds * 1000)
  }

  /**
   * Convert a Unix timestamp in milliseconds into one in seconds, without decimal places. Most of our code assumes
   * integer timestamps in seconds, and so things can break in unexpected ways if we do this inconsistently.
   */
  public static msToTs(ms: number): number {
    // never return fractional seconds
    return Math.floor(ms / 1000)
  }

  /**
   * Convert an ISO-8601-formatted datetime with offset (e.g. 2023-06-13T14:30+03:00) into a Unix timestamp in seconds.
   */
  public static convertIso8601ToTs(iso8601DateTime: string): number {
    return this.toTs(new Date(iso8601DateTime))
  }

  public static convertTsToIso8601(ts: number): string {
    return new Date(ts * 1000).toISOString()
  }

  public static convertIso8601DurationToSeconds(iso8601Duration: string): number {
    return moment.duration(iso8601Duration).asSeconds()
  }

  public static convertSecondsToIso8601Duration(seconds: number): string {
    return moment.duration(seconds, 'seconds').toISOString()
  }
}
